<template>
  <el-drawer :visible.sync="drawerVisible" :before-close="onDrawerClose">
    <div slot="title" class="message-list-drawer-header">
      <span>{{ title }}</span>
      <el-button
        type="primary"
        plain
        size="mini"
        @click="onAllReadClick"
        style="margin-right: 15px"
      >
        全部已读
      </el-button>
    </div>
    <div class="message-list-drawer-content" v-loading="loading">
      <div class="message-list-container">
        <MessageList
          :items="messageList"
          @onMsgItemClick="onMsgItemClick"
          @onPageJump="onPageJump"
        />
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          :current-page="pagination.currentPage"
          @current-change="onPageChange"
        ></el-pagination>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import MessageList from "./messageList.vue";

export default {
  components: {
    MessageList,
  },
  props: {
    title: {
      type: String,
      default: "消息列表",
    },
    // 外部传入，获取消息列表方法
    getMessageList: {
      type: Function,
      // eslint-disable-next-line
      default: () => {},
    },
  },
  data() {
    return {
      // 数据加载中
      loading: false,
      // 展示抽屉
      drawerVisible: false,
      // 消息列表
      messageList: [],
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    onDrawerClose() {
      this.drawerVisible = false;
    },
    // 获取当前页消息列表
    getCurrentPageData(showLoading = true) {
      if (showLoading) {
        this.loading = true;
      }
      const params = {
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      return this.getMessageList(params)
        .then((res) => {
          this.messageList = res.records;
          this.pagination.total = res.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 打开
    show() {
      // 重置分页
      this.pagination.currentPage = 1;
      // 获取消息列表
      this.getCurrentPageData();
      // 显示抽屉
      this.drawerVisible = true;
    },
    // 刷新当前页
    refresh(showLoading) {
      this.getCurrentPageData(showLoading);
    },
    // 点击分页
    onPageChange(current) {
      this.pagination.currentPage = current;
      this.getCurrentPageData();
    },
    // 单条消息被点击
    onMsgItemClick(item) {
      this.$emit("onMsgItemClick", item);
    },
    // 点击全部已读
    onAllReadClick() {
      this.$emit("onAllReadClick");
    },
    // 跳转到对应页面
    onPageJump(data) {
      console.log("onPageJump-----1122", data);
      this.$emit("onPageJump", data);
      this.onDrawerClose();
    },
  },
};
</script>

<style lang="scss" scoped>
.message-list-drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.message-list-drawer-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  .message-list-container {
    flex: 1;
    height: 0;
    overflow-y: auto;
    padding: 20px;
    box-sizing: border-box;
  }
  .pagination-container {
    padding: 20px;
    box-sizing: border-box;
    text-align: right;
  }
}
</style>
